import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
export type FormHintProps = {
  children?: React.ReactNode;
  className?: string;
  textAlign?: 'left' | 'right';
};
const FormHint = t0 => {
  const $ = _c(8);
  const {
    children,
    className,
    textAlign: t1
  } = t0;
  const textAlign = t1 === undefined ? "left" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cx("fp-hint fp-custom-appearance whitespace-normal", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== textAlign) {
    t3 = {
      textAlign
    };
    $[2] = textAlign;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2} data-size="default" style={t3}>{children}</div>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default FormHint;